class ERHomepage {
  constructor(root) {
    this.root = root;
    this.dialog = root.querySelector('[data-er-lightbox-dialog]');
    this.dialogImage = this.dialog?.querySelector('img');
    this.verseSection = root.querySelector('[data-er-daily-verse]');
    this.verseTimer = null;
    this.bindEvents();
    this.initDailyVerse();
  }

  bindEvents() {
    if (!this.dialog || !this.dialogImage) return;

    this.root.querySelectorAll('[data-er-lightbox]').forEach((button) => {
      button.addEventListener('click', () => {
        this.dialogImage.src = button.dataset.image;
        if (typeof this.dialog.showModal === 'function') this.dialog.showModal();
      });
    });

    this.root.querySelector('[data-er-lightbox-close]')?.addEventListener('click', () => this.dialog.close());
    this.dialog.addEventListener('click', (event) => {
      if (event.target === this.dialog) this.dialog.close();
    });
  }

  initDailyVerse() {
    if (!this.verseSection) return;

    const source = this.verseSection.querySelector('[data-er-daily-verses]');
    try {
      this.verses = JSON.parse(source?.textContent || '[]');
    } catch (error) {
      this.verses = [];
    }

    if (!this.verses.length) return;
    this.renderDailyVerse();
    this.scheduleNextVerse();
  }

  bucharestDateParts(date = new Date()) {
    const parts = new Intl.DateTimeFormat('en-CA', {
      timeZone: 'Europe/Bucharest',
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
    }).formatToParts(date);

    return parts.reduce((result, part) => {
      if (part.type !== 'literal') result[part.type] = Number(part.value);
      return result;
    }, {});
  }

  bucharestDateKey(date = new Date()) {
    const { year, month, day } = this.bucharestDateParts(date);
    return `${year}-${String(month).padStart(2, '0')}-${String(day).padStart(2, '0')}`;
  }

  renderDailyVerse() {
    const { year, month, day } = this.bucharestDateParts();
    const dateKey = `${year}-${String(month).padStart(2, '0')}-${String(day).padStart(2, '0')}`;
    if (this.verseSection.dataset.erVerseDate === dateKey) return;

    const firstRotationDay = Date.UTC(2026, 7, 4) / 86400000;
    const currentDay = Date.UTC(year, month - 1, day) / 86400000;
    const index = ((currentDay - firstRotationDay) % this.verses.length + this.verses.length) % this.verses.length;
    const verse = this.verses[index];

    this.verseSection.querySelector('[data-er-verse-text]').textContent = verse.text;
    this.verseSection.querySelector('[data-er-verse-reference]').textContent = verse.reference;
    this.verseSection.dataset.erVerseDate = dateKey;
  }

  scheduleNextVerse() {
    const now = Date.now();
    const today = this.bucharestDateKey(new Date(now));
    let low = now;
    let high = now + 27 * 60 * 60 * 1000;

    while (high - low > 1000) {
      const middle = Math.floor((low + high) / 2);
      if (this.bucharestDateKey(new Date(middle)) === today) low = middle;
      else high = middle;
    }

    this.verseTimer = window.setTimeout(() => {
      this.renderDailyVerse();
      this.scheduleNextVerse();
    }, Math.max(1000, high - now + 1000));
  }

  destroy() {
    if (this.verseTimer) window.clearTimeout(this.verseTimer);
  }
}

const initERHomepages = (scope = document) => {
  scope.querySelectorAll('.er-home').forEach((root) => {
    if (root.dataset.erInitialized) return;
    root.dataset.erInitialized = 'true';
    root.erHomepageInstance = new ERHomepage(root);
  });
};

document.addEventListener('DOMContentLoaded', () => initERHomepages());
document.addEventListener('shopify:section:load', (event) => initERHomepages(event.target));
document.addEventListener('shopify:section:unload', (event) => {
  event.target.querySelectorAll('.er-home').forEach((root) => root.erHomepageInstance?.destroy());
});
